module.exports = __webpack_public_path__ + "img/icon_phone.65ef7eca.svg";